import { iconsSet } from "../../../../assets/icons/icons";
// import defaultContent from "../default";
export default {
  hero: {
    img: {
      url: "https://ontick-img.s3.sa-east-1.amazonaws.com/parceiros/mockup_lp_midas.png",
      alt: "Midas Robôs",
    },
    title: "Opere com o Midas Robôs",

    // String ou array de strings
    text: [
      "Desenvolvemos robôs de investimento utilizando as mais recentes técnicas de otimização e inteligência artificial, com o objetivo de maximizar a performance e a segurança de cada operação. Com foco não apenas em rentabilidade, mas também em uma gestão rigorosa de riscos e na longevidade de cada estratégia, validamos minuciosamente cada solução antes de disponibilizá-la, garantindo consistência e robustez nos resultados. Esteja à frente do mercado com a Midas Robôs e descubra como nossa abordagem inovadora pode transformar seus investimentos. Saiba mais em http://www.midasrobos.com.br/ e em @midasrobos.",
    ],
    testimonial: {
      text: "Usamos otimização e Inteligência Artificial para aprimorar continuamente nossas estratégias de negociação.",
      author: {
        name: "Equipe Midas Robôs",
        // picture:
        //   "https://ontick-img.s3.sa-east-1.amazonaws.com/parceiros/foto-edson-3-150x150.jpg",
      },
    },
  },

  strategies: {
    title: "Estratégias do Midas Robôs",
    heading: "O Poder da Otimização e Inteligência Artificial em Suas Mãos",
    subtitle:
      "Com apenas alguns cliques, acesse estratégias inteligentes e personalizadas. Potencialize seus investimentos com total controle e segurança.",
  },

  cta: {
    title: "Pronto para começar?",
    subtitle: "Ative agora mesmo a extensão Midas Robôs e potencialize seus investimentos. ",
  },

  about: {
    title: "Sobre o desenvolvedor",
    subtitle: "A Midas Robôs",
    col1: [
      "Unimos ciência e tecnologia para desenvolver robôs de investimento e estratégias de negociação personalizadas. Utilizando técnicas avançadas de otimização e inteligência artificial, aprimoramos continuamente a performance de nossas estratégias. Com total controle sobre nossos algoritmos, oferecemos soluções robustas que se adaptam a diferentes mercados.",
    ],
    col2: [
      "Desenvolvemos robôs de investimento utilizando as mais recentes técnicas de otimização e inteligência artificial, com o objetivo de maximizar a performance e a segurança de cada operação. Nossa plataforma permite personalização total das estratégias, assegurando controle absoluto sobre as operações e transparência em todos os processos. Com foco não apenas em rentabilidade, mas também na gestão de riscos e na longevidade de cada estratégia, validamos minuciosamente cada solução antes de disponibilizá-la, garantindo consistência e robustez nos resultados. Esteja à frente do mercado com a Midas Robôs e descubra como nossa abordagem inovadora pode transformar seus investimentos. Saiba mais em http://www.midasrobos.com.br/",
    ],
  },

  // stats: {
  //   title: "ph",
  //   subtitle: "ph",
  //   data: [
  //     {
  //       value: "ph",
  //       description: "ph",
  //     },
  //     {
  //       value: "ph",
  //       description: "ph",
  //     },
  //     {
  //       value: "ph",
  //       description: "ph",
  //     },
  //   ],
  // },

  features: {
    title: "Por que utilizar os robôs da Midas?",
    subtitle: "Veja quais as principais vantagens dos nossos robôs",
    data: [
      {
        icon: iconsSet.settings,
        title: "Otimização e Inteligência Artificial",
        description:
          "Nossas estratégias são continuamente aprimoradas por algoritmos de inteligência artificial e técnicas avançadas de otimização. Isso garante que seus investimentos estejam sempre ajustados às condições de mercado, maximizando o potencial de retorno com eficiência e precisão.",
      },
      {
        icon: iconsSet.test_tube,
        title: "Backtest Avançado",
        description:
          "Nossas estratégias são rigorosamente testadas em diversos cenários de mercado. Com nosso sistema de backtest avançado, você tem total transparência sobre o desempenho passado, permitindo confiança e segurança para suas operações futuras.",
      },
      {
        icon: iconsSet.lightning,
        title: "Alta Velocidade e Eficiência",
        description:
          "Nossos algoritmos processam milhares de cálculos por segundo, proporcionando decisões mais rápidas e precisas.",
      },
      {
        icon: iconsSet.hourglass,
        title: "Economia de Tempo",
        description: "Deixe nossos robôs operarem por você. Ganhe mais tempo para focar no que realmente importa. ",
      },
      {
        icon: iconsSet.balance,
        title: "Sem Interferência Emocional",
        description:
          "Elimine decisões impulsivas e emocionais com nossas estratégias automatizadas, focadas em resultados consistentes.",
      },
      {
        icon: iconsSet.editParams,
        title: "100% Automatizado",
        description:
          "Nossos robôs são totalmente ajustáveis às suas necessidades e automatizam suas estratégias com precisão.",
      },
    ],
  },

  // testimonials: [
  //   {
  //     text: "Conseguiram aliar a experiência de mercado as mais novas tendências tecnológicas e gerar estratégias bem consistentes",
  //     author: "Rafael Rodrigues",
  //     job: "Programador",
  //     // image_url:
  //     //   "https://newbot.com.br/wp-content/uploads/2018/03/eliseu-sandres-120x120.jpg",
  //   },
  //   {
  //     text: "Amo day trade, mas entendi que os vieses emocionais me prejudicavam demais e ao utilizar os robôs, ganhei tempo livre, sem perder a chance de ganhar dinheiro dia a dia ",
  //     author: "Rodolfo Napolitano",
  //     job: "Engenheiro Civil",
  //     // image_url:
  //     //   "https://newbot.com.br/wp-content/uploads/2018/03/Victor-nardi-vilella-120x120.jpg",
  //   },
  // ],

  plans: {
    title: "Planos",
    subtitle: "Conheça os planos da extensão Midas Robôs",
  },
};
